import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosServiceInstance } from '../axios';
import { MEDIA_ENTITY } from './entity';

export const useDeleteMediaFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (id: string) => {
      await axiosServiceInstance.delete(`/${MEDIA_ENTITY}/${id}`);
    },
    onSuccess: () => {
      // Invalidate everything under the media key — refreshes the grid AND the upload-quota usage.
      queryClient.invalidateQueries({ queryKey: [MEDIA_ENTITY], exact: false });
    },
  });
};
